import React from "react";
import { motion } from "framer-motion";
import { ChefHat, Shirt, Sparkles, ShoppingBag, Home as HomeIcon, HeartPulse } from "lucide-react";

const ORBIT_ICONS = [
  { Icon: ChefHat, label: "Meal", color: "#F28C82" },
  { Icon: Shirt, label: "Outfit", color: "#F5C86B" },
  { Icon: Sparkles, label: "Beauty", color: "#B8E3D9" },
  { Icon: ShoppingBag, label: "Shopping", color: "#F28C82" },
  { Icon: HomeIcon, label: "Home", color: "#F5C86B" },
  { Icon: HeartPulse, label: "Wellness", color: "#B8E3D9" },
];

export default function OrbitHero() {
  const radius = 150;
  return (
    <div data-testid="orbit-hero" className="relative flex h-[420px] w-[420px] max-w-full items-center justify-center md:h-[500px] md:w-[500px]">
      {/* soft glow rings */}
      <div className="absolute inset-0 rounded-full border border-[#4B2E5A]/8" />
      <div className="absolute inset-[15%] rounded-full border border-[#4B2E5A]/8" />

      {/* central figure */}
      <div className="relative z-10 h-40 w-40 overflow-hidden rounded-full shadow-[0_20px_60px_rgba(75,46,90,0.18)] ring-4 ring-white md:h-52 md:w-52">
        <img
          src="https://images.pexels.com/photos/30364581/pexels-photo-30364581.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="A woman navigating everyday decisions"
          className="h-full w-full object-cover"
        />
      </div>

      {/* rotating orbit */}
      <motion.div
        className="absolute inset-0"
        animate={{ rotate: 360 }}
        transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
      >
        {ORBIT_ICONS.map(({ Icon, label, color }, i) => {
          const angle = (i / ORBIT_ICONS.length) * 2 * Math.PI;
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;
          return (
            <motion.div
              key={label}
              className="absolute left-1/2 top-1/2 flex flex-col items-center"
              style={{ x, y, translateX: "-50%", translateY: "-50%" }}
              animate={{ rotate: -360 }}
              transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
            >
              <div
                className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/80 shadow-[0_8px_24px_rgba(75,46,90,0.1)] backdrop-blur-md md:h-16 md:w-16"
                style={{ border: `1px solid ${color}55` }}
              >
                <Icon className="h-6 w-6 md:h-7 md:w-7" strokeWidth={1.5} style={{ color }} />
              </div>
              <span className="mt-1.5 text-[11px] font-medium text-[#4B2E5A]/60">{label}</span>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  );
}
